// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonDarkMode_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8817 2.06227C12.4388 1.3065 13.1095 0.620991 13.8861 0.0334885C11.5652 -0.140178 9.16937 0.358137 7.00172 1.60963C1.26244 4.92321 -0.703981 12.262 2.60959 18.0013C5.92317 23.7406 13.262 25.7027 19.0012 22.3891C20.2158 21.6879 21.2614 20.8107 22.1238 19.8022C22.8004 19.0109 23.3643 18.1413 23.8084 17.2194C22.9113 17.5982 21.9823 17.8363 21.0492 17.9409C17.2192 18.3704 13.3197 16.5526 11.2695 13.0015C9.21928 9.4504 9.59468 5.16443 11.8817 2.06227ZM19.0447 19.9697C15.2205 19.6836 11.5996 17.5731 9.53753 14.0015C7.47544 10.4298 7.45818 6.23873 9.12249 2.78379C8.74247 2.94427 8.36816 3.13003 8.00168 3.34161C3.21895 6.10292 1.58026 12.2186 4.34157 17.0013C7.10289 21.784 13.2185 23.4227 18.0013 20.6614C18.3677 20.4498 18.7157 20.2186 19.0447 19.9697Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.3276 2.0993C12.0679 6.44914 11.5158 12.497 14.4056 17.5022C17.2953 22.5074 22.809 25.0532 28.2059 24.4052C29.1423 24.2927 30.0754 24.0843 30.9905 23.7756C30.5043 24.6526 29.9333 25.4878 29.2813 26.2678C28.1099 27.6692 26.6764 28.8837 25.0027 29.85C17.35 34.2683 7.56454 31.6554 3.14627 24.0027C-1.27201 16.35 1.34999 6.56454 9.00267 2.14626C10.6765 1.17989 12.4523 0.550321 14.2517 0.236522C15.2532 0.0618914 16.2624 -0.0149862 17.265 0.00240311C16.5402 0.640539 15.8933 1.34459 15.3276 2.0993ZM26.2671 26.5025C20.8357 26.4081 15.5874 23.5492 12.6735 18.5022C9.75957 13.4552 9.90791 7.48039 12.542 2.72943C11.6755 3.02165 10.825 3.40353 10.0027 3.87831C3.30657 7.74431 1.01232 16.3066 4.87832 23.0027C8.74431 29.6988 17.3066 31.993 24.0027 28.127C24.8249 27.6523 25.5808 27.1067 26.2671 26.5025Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonDarkMode is a generated icon component.
 */
let IconCommonDarkMode = IconCommonDarkMode_1 = class IconCommonDarkMode extends IconBaseElement {
    render() {
        return html `${IconCommonDarkMode_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonDarkMode.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconCommonDarkMode = IconCommonDarkMode_1 = __decorate([
    customElement('zui-icon-common-dark-mode')
], IconCommonDarkMode);
export { IconCommonDarkMode };
